import Element from 'types/redux/Element';
import ListCollection from 'types/redux/ListCollection';

import CmsPage from 'models/CmsPage';
import Location from 'models/Location';

import { ELEMENT_MARKUP, LIST_MARKUP } from 'consts/redux';

import { single as singleCmsPage } from 'requests/cmsPages';
import { listNearby, single } from 'requests/locations';

import Component from './component';
import { NextPageContextWithCookies, Props } from './types';

Component.getInitialProps = async (appContext: NextPageContextWithCookies): Promise<Props> => {
    let location: Element<Location> = ELEMENT_MARKUP;
    let locationsNearby: ListCollection<Location> = LIST_MARKUP;
    let cmsPage: Element<CmsPage> = ELEMENT_MARKUP;
    const { slug } = appContext.query;

    try {
        await Promise.all([
            single({ slug: slug.toString() }),
        ]).then((responses) => {
            location = responses[0];
        });
    } catch (error) {
        appContext.res.statusCode = 404;

        console.error(error);
        return {
            notFound: true,
        };
    }

    try {
        await Promise.all([
            singleCmsPage({ slug: 'location' }),
        ]).then(response => {
            cmsPage = response[0];
        });
    } catch (error) {
        console.error(error);
    }

    if (location) {
        try {
            await Promise.all([
                listNearby({
                    perPage: 3,
                    citySlug: location?.data?.city?.slug,
                    voivodeshipSlug: location?.data?.city?.voivodeship?.slug,
                    ignoreIds: [location?.data?.id],
                }),
            ]).then((responses) => {
                locationsNearby = responses[0];
            });
        } catch (error) {
            console.error(error);
        }
    }

    return {
        location: location?.data || null,
        locationsNearby: locationsNearby || null,
        cmsPage: cmsPage || null,
    };
};

export default Component;